import { FC } from "react";
import { useMatch } from "react-router";
import { AllType, isAllType, RoutePath } from "src/data/Routes";
import NavigateRoute from "./NavigateRoute";
import { useNavProps } from "./useNavProps";

function isDevice(section: string) {
  const secPath = '/' + section;
  return secPath !== RoutePath.DASHBOARD && secPath != RoutePath.CUSTOM_GROUPS && secPath !== RoutePath.SETTINGS;
}

export const RouteSectionCmp: FC = () => {
  const match = useMatch(RoutePath.MATCH_SECTION_CMP);
  const navProps = useNavProps(search => {
    const cls = match.params.section;
    let cmp = match.params.cmp;
    const cmpPath = '/' + cmp;
    let allType: AllType;
    let typeOrDevice: string;
    if (isAllType(cmpPath)) {
      allType = cmpPath;
      cmp = null;
    } else if (isDevice(cls)) {
      typeOrDevice = cmp;
      cmp = null;
    }
    return { clsName: cls, allType, typeOrDevice, itemName: cmp, search };
  }, [match.params]);

  return navProps && <NavigateRoute {...navProps} />;
};
